export default __webpack_public_path__ + "locales/ro/DeleteThirdPartyDialog.json?hash=b94a8f6291edd297bd139231e3e83914";